<template>
  <div class="login-wrapper">
    <p class="notification" v-if="WARNING_MESSAGE" v-html="WARNING_MESSAGE"></p>
    <div class="login">
      <img src="../assets/login-icon.svg"/>
      <h3 class="title is-5">Вход в кабинет</h3>
      <form @submit.prevent="signIn">
        <b-field class="login-field">
          <form-input label="Введите логин или email" v-model="login"></form-input>
        </b-field>
        <b-field class="login-field">
          <form-input type="password" label="Введите пароль" v-model="password"></form-input>
        </b-field>
        <b-field>
          <button class="button is-primary" type="submit">Войти</button>
        </b-field>
      </form>
      <a class="esi-link" href='https://esi.uz/oauth2/authorize?client_id=D87F4631D3EE3224&scope=public-info+certificate-info&response_type=code&state={"custom": "state"}&redirect_uri=https://ijro.xtv.uz/oauth'>
        <b-icon icon="key" size="is-small"></b-icon>
        Войти с помощью ЭЦП
      </a>
    </div>
    <div class="mobileApp" v-if="ANDROID_APP">
      <div class="qrCode">
        <img :src="androidQR" alt="QR">
      </div>
      <a :href="ANDROID_APP" class="downloadButton">
        <b-icon class="icon" icon="android-debug-bridge"></b-icon>
        <span>
            <span>Скачать приложение</span>
            Android
          </span>
      </a>
    </div>
  </div>
</template>

<script>
  import {WARNING_MESSAGE, ANDROID_APP} from '@/localSettings'
  import QRCode from 'qrcode'
  import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        login: '',
        password: '',
        androidQR: null,
        ANDROID_APP,
        WARNING_MESSAGE
      }
    },
    methods: {
      signIn() {
        this.$store.dispatch('Account/login', {
          username: this.login,
          password: this.password
        }).then((account) => {
          this.$auth.bind(account.token)
          this.$locale.change(account.locale)
          this.$router.push({name: this.isDocflowHead ? 'extendedDashboard' : 'dashboard'})
        }).catch((error) => {
          switch (error.status) {
            case 401:
              this.$toast.open({
                message: `Неверный логин или пароль`,
                type: 'is-danger'
              })
              break;
            case 400:
              this.$toast.open({
                message: `Необходимо заполнить все поля`,
                type: 'is-danger'
              })
              break;
            default:
              this.$toast.open({
                message: `Неизвестная ошибка`,
                type: 'is-danger'
              })
              break;
          }
        })
      }
    },
    mounted() {
      QRCode.toDataURL(this.ANDROID_APP).then((qr) => this.androidQR = qr)
    },
    computed: {
      ...mapGetters('Account', ['isDocflowHead']),
    }
  }
</script>

<style lang="scss" scoped>
  .login-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f4f5fa;

    .esi-link {
      display: block;
      margin-top: 10px;
    }

    .login {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 380px;
      margin: 0 auto;
      box-shadow: -10px 9px 21px rgba(128, 152, 213, 0.074983);
      background: #fff;
      padding: 45px 60px;

      text-align: center;

      img {
        display: block;
        margin: 0 auto;
      }

      .title {
        margin: 38px 0 28px;
        color: #686868;
        font-size: 20px;
      }

      .login-field {
        margin-bottom: 15px;
      }

      button[type="submit"] {
        width: 140px;
      }
    }

    .notification {
      width: 800px;
      margin: 20px auto 0;
      padding: 15px 20px;
      background: #ffdb00;
      span {
        display: block;
        &:not(:last-child) {
          margin-bottom: 4px;
        }
      }
    }

    .mobileApp {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);

      .qrCode {
        width: 148px;
        height: 148px;
        margin: 0 auto;
        position: relative;
        top: -10px;
        box-shadow: 0 0 20px rgba(128, 152, 213, .2), 0 0 5px rgba(128, 152, 213, .3);
        opacity: 0;
        display: none;

        img {
          width: 100%;
          height: auto;
        }
      }

      &:hover {
        .qrCode {
          display: block;
          opacity: 1;
        }
      }

      .downloadButton {
        background: #222;
        color: #fff;
        border: 0;
        display: flex;
        flex-direction: row;
        border-radius: 5px;
        padding: 8px 15px 8px 10px;
        text-align: left;

        span {
          display: inline-block;
          font-size: 18px;
          line-height: 20px;
          font-weight: 500;
          & > span {
            display: block;
            font-size: 10px;
            line-height: 14px;
            font-weight: normal;
            color: #bbb;
          }
        }

        .icon {
          width: 28px;
          margin-top: 7px;
          margin-right: 4px;
        }
      }
    }
  }
</style>
